import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Avatar, Button } from "@material-ui/core";
import { CryptoState } from '../../CryptoContext';
import { signOut } from 'firebase/auth';
import { auth, db } from '../../firebase';
import { numberWithCommas } from '../Carousel';
import { AiFillDelete } from 'react-icons/ai';
import { doc, setDoc } from 'firebase/firestore';
import { CoinList } from '../../config/api';


const useStyles = makeStyles({
    container: {
      width: 350,
      padding: 25,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      fontFamily: "monospace",
      backgroundColor: ' rgba(4, 16, 79, 1)',
    },
    profile: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "20px",
      height: "92%",
    },
    logout: {
      height: "8%",
      width: "100%",
      backgroundColor: "#e64072",
      marginTop: 20,
      color:"white"
    },
    picture: {
      width: 200,
      height: 200,
      cursor: "pointer",
      backgroundColor: "#e64072",
      objectFit: "contain",
    },
    watchlist: {
      flex: 1,
      width: "100%",
      backgroundColor: "rgba(50, 60, 129, 1.0)",
      borderRadius: 10,
      padding: 15,
      paddingTop: 10,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 12,
      overflowY: "scroll",
    },
    coin: {
      padding: 10,
      borderRadius: 5,
      color: "black",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#e64072",
      boxShadow: "0 0 3px black",
    },
  });

export default function Usersidebar() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const { user,setAlert ,watchlist,coins,symbol} = CryptoState()

  const logOut = ()=>{
    signOut(auth)
    setAlert({
        open:true,
        type:"success",
        message:"Logout Successful !"
    })
    toggleDrawer()
  }

  const removeFromWatchlist = async (coin)=>{
    const coinRef = doc(db,"watchlist",user.uid);//reference to the table

    try{
      await setDoc(
        coinRef,
        {
          coins:watchlist.filter((watch)=>watch !== coin?.id)
        },
        {merge:"true"}
      );
      setAlert({
        open:true,
        message:`${coin.name} Removed from the watchlist !`,
        type:"success"
      })
    }catch(err){
      setAlert({
        open:true,
        message:err.message,
        type:"error"
      })
    }
  }

  
  return (
    <div>
      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Avatar onClick={toggleDrawer(anchor, true)}
            style={{
                height: 38,
                width: 38,
                cursor: "pointer",
                backgroundColor:"#e64072"
              }}
              src={user.photoURL}
              alt={user.displayName || user.email}
          />
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            <div className={classes.container}>
              <div className={classes.profile}>
              <Avatar
              className={classes.picture}
              src={user.photoURL}
              alt={user.displayName || user.email}
          />
                <span style={{
                    width: "100%",
                    fontSize: 25,
                    textAlign: "center",
                    fontWeight: "bolder",
                    wordWrap: "break-word",
                  }}
                  > 
                    {user.displayName || user.email}
                </span>
                <div className={classes.watchlist}>
                  <span style={{ fontSize: 15, textShadow:"0 0 5px black"}}>
                    Watchlist
                  </span>
                  {
                    coins.map(coin =>{
                      if(watchlist.includes(coin.id))
                        return (
                          <div className={classes.coin}>
                            <span>{coin.name}</span>
                            <span style={{display:"flex",gap:8}}>
                              {symbol}
                              {numberWithCommas(coin.current_price.toFixed(2))}
                              <AiFillDelete 
                                style={{
                                  cursor:"pointer",
                                }}
                                fontSize="16"
                                onClick={()=>removeFromWatchlist(coin)}
                              />
                            </span>
                          </div>
                        );
                    })
                  }



                </div>
              </div>
              <Button variant='contained' className={classes.logout} onClick={logOut}>
                Log Out
              </Button>
            </div>
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
